//项目配置文件
let api = process.env.NODE_ENV === 'production'?'https://www.gdyuanwo.com/gdyuanwo/gpa/gpwx':'https://www.gdyuanwo.com/gdyuanwo/gpa/gpwx'
let img_api=process.env.NODE_ENV === 'production'?'https://www.gdyuanwo.com/gdyuanwo/':'https://www.gdyuanwo.com/gdyuanwo/'
export default {
    api,
    img_api
}